import { BurgerMenu } from "../BurgerMenu/index";
import { HeaderLogo } from "../HeaderLogo/index";
import { ModeSwitchIcons } from "../ModeSwitchIcons/index";
import { NAV_ITEMS } from "../../navigation/navItems";
import "./style.css";

export const Header = () => (
  <header className="header">
    <HeaderLogo />
    <div className="header__controls">
      <nav className="nav">
        {NAV_ITEMS.map((item) => (
          <button key={item.target} type="button" className="nav__link" data-nav-target={item.target}>
            {item.label}
          </button>
        ))}
      </nav>
      <button className="mode-switch" type="button" data-mode-switch aria-pressed="false" aria-label="Toggle night mode">
        <span className="mode-switch__track" aria-hidden="true">
          <ModeSwitchIcons />
          <span className="mode-switch__thumb" aria-hidden="true" />
        </span>
      </button>
      <BurgerMenu />
    </div>
  </header>
);
